import React from "react"
import { Helmet } from "react-helmet"

const Seo = ({
	title,
	description,
  url = null
}) => {

	const formattedTitle = title ? `${title} – Engineered Floors` : 'Engineered Floors'

  return (
    <Helmet title={formattedTitle}>
      <meta name="description" content={description} />

      {title && <meta property="og:title" content={`${title} - Engineered Floors`} />}
			{title && <meta name="twitter:title" content={`${title} - Engineered Floors`} />}

      {description && <meta property="og:description" content={description} />}
			{description && <meta name="twitter:description" content={description} />}

			<meta property='og:url' content={url !== null ? url : "https://engineeredfloors.com/"}/>

			<script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/21741430.js"></script>
      <script async defer src="https://static.cdn.prismic.io/prismic.js?new=true&repo=engineered-floors"></script>
    </Helmet>
  )
}

export default Seo